'use client';

import { ChangeEvent } from 'react';

interface IRadioButtonProps {
  name: string;
  id: string;
  defaultValue?: boolean;
  value: boolean | undefined;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const RadioButton = ({ name, id, defaultValue = false, value,  handleChange }: IRadioButtonProps) => (
  <input id={id} className="radio-button" type="radio" name={name} checked={value ?? defaultValue} onChange={handleChange} />
);
